// components
import { NoGoView } from './no-go-view';
import { Modal, ModalContent } from 'shared/components/bulma/modal';

const ModalNoGos = ({ modal, handleModal, product, customer }) => {

    const handleExit = () => {
        handleModal(false);
    };

    if (!product) {
        return null;
    };

    const title = [customer.full_name, 'No-Gos for', product.barcode].join(' ');

    return (
        <Modal title={title} isActive={modal} onExit={handleExit}>
            <ModalContent>
                <NoGoView product={product} customer={customer} />
            </ModalContent>
        </Modal>

    );
}

export { ModalNoGos };
